export const environment = {
    production: true,
    apiUrl: 'https://app.customnuturepages.com/'
};
